<template>
  <div class="dettaglio-trasferte" v-loading="loading">
    <div class="header-tab row row-custom">

      <div class="return col-8">
        <icon v-if="$route.name === 'home' ? false : true" name="riv-arrow2" scale="2" flip="horizontal"
          @click.native="link('RiepilogoAutorizzazioni')"></icon>
      </div>
      <div class="col-8">
        <span class="my-label">{{ $t('autorizza.label.title').toUpperCase() }}</span>
        <span class="my-label-subtitle">{{ getStato() }}</span>
      </div>
      <div class="col-8 inoltraBtn">
        <el-button class="WEB-button WEB-button-primary right" v-if="trasferta.statoAvanz === '1'"
          :disabled="!diario_toApprove" @click="actionTrasferta('3')">
          {{ $t('btn.approva').toUpperCase() }}
        </el-button>
        <el-button class="WEB-button WEB-button-alternative right" v-if="trasferta.statoAvanz === '1'"
          @click="actionTrasferta('2')">
          {{ $t('btn.rifiuta').toUpperCase() }}
        </el-button>
      </div>

    </div>

    <div class="testata-trasferte row row-custom">
      <div class="colonna col-md-12 col-24">
        <div class="blocco">
          <div class="elemento row row-custom">
            <div class="testata-label col-md-8 col-10">
              {{ $t('trasferte.periodo') }}
            </div>
            <div class="testata-value col-md-16 col-14" v-if="trasferta.tipoTrasferta === 'ORE'">
              {{ trasferta.dataDal | formattaData }} {{ '(' + trasferta.oraDal + ' - ' + trasferta.oraAl +')'}}
            </div>
            <div class="testata-value col-md-16 col-14" v-else>
              {{ trasferta.dataDal | formattaData }} - {{ trasferta.dataAl | formattaData }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="trasferta.tipoTrasferta === 'ORE'">
            <div class="testata-label col-md-8 col-10">
              {{ $t('trasferte.numOre') }}
            </div>
            <div class="testata-value col-md-16 col-14">
              {{ trasferta.oreTrasferta }}
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="testata-label col-md-8 col-10">
              {{ $t('autorizza.label.partenza') }} / {{ $t('autorizza.label.destinazione') }}
            </div>
            <div class="testata-value col-md-16 col-14">
              {{ trasferta.desProv }} / {{ trasferta.desDest === undefined ? trasferta.desMan : trasferta.desDest }}
            </div>
          </div>
          <!--<div class="elemento row row-custom">
            <div class="testata-label col-md-8 col-10">
              {{ $t('autorizza.label.destinazione') }}
            </div>
            <div class="testata-value col-md-16 col-14">
              {{ trasferta.desDest === '' ? trasferta.desMan : trasferta.desDest}}
            </div>
          </div>-->
          <div class="elemento row row-custom">
            <div class="testata-label col-md-8 col-10">
              {{ $t('autorizza.label.soc') }}
            </div>
            <div class="testata-value col-md-16 col-14">
              {{ trasferta.desCli }} <span style="text-transform: capitalize">( {{ trasferta.desUff !== undefined ?
                trasferta.desUff.toLowerCase() : '' }} )</span>
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="testata-label col-md-8 col-10">
              {{ $t('autorizza.label.referente') }}
            </div>
            <div class="testata-value col-md-16 col-14">
              {{ getContatti(trasferta.contatti, trasferta.perRif) }}
            </div>
          </div>
        </div>

      </div>

      <div class="colonna col-md-12 col-24">

        <div class="blocco">
          <div class="elemento row row-custom">
            <div class="testata-label col-md-8 col-10">
              {{ $t('autorizza.label.motivo') }}
            </div>
            <div class="testata-value col-md-16 col-14" v-html="getMotivo(trasferta.notaDip)"
              style="white-space: pre-line">
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="testata-label col-md-8 col-10">
              {{ $t('autorizza.label.notaResp') }}
            </div>
            <div class="testata-value col-md-16 col-14">
              <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 4 }" placeholder=""
                v-model="trasferta.notaResp" :disabled="trasferta.statoAvanz !== '1'">
              </el-input>
            </div>
          </div>
        </div>

      </div>
    </div>

    <el-tabs v-model="tabActive" type="card" class="col-24" v-loading="loading">
      <el-tab-pane>
        <div style="width: 200px" slot="label">
          <div class="col-24 no-padding">
            {{ $t('trasferte.diario').toUpperCase() }}
          </div>
          <div class="col-24 no-padding barra"></div>
        </div>

        <div class="dettaglio-diario">
          <span class="info-diario">{{ $t('autorizza.label.authDiary') }}</span>
          <!--<div class="info-diario"><el-select v-model="statusDiario" placeholder="Select" @change="loadDiario">
            <el-option
              v-for="item in stati"
              :key="item.id"
              :label="item.desc"
              :value="item.id">
            </el-option>
          </el-select>
          </div>-->

          <el-table :data="diario" row-class-name="single riga-hover" row-key="id"
            :empty-text="$t('autorizza.msg.noData')" v-loading="loading" class="custom-table">


            <el-table-column width="50">
              <template slot-scope="scope">
                <div class="data-wrapper">
                  <el-tooltip class="item" effect="dark" :content="$t('statusDett.' + scope.row.statoAvanz)"
                    placement="top-start">
                    <icon :name="getStatoIcon_dett(scope.row.statoAvanz)"
                      :class="getStatoClass_dett(scope.row.statoAvanz)" scale="1.2"></icon>
                  </el-tooltip>
                </div>
              </template>

            </el-table-column>
            <el-table-column header-align="center" align="center" :label="$t('autorizza.label.giorno')" width="100">

              <template slot-scope="scope">
                <div class="data-wrapper">
                  {{ scope.row.giorno | formattaData }}
                </div>
              </template>
            </el-table-column>
            <el-table-column header-align="center" align="center" :label="$t('autorizza.label.orario')" width="100">

              <template slot-scope="scope">
                <div class="data-wrapper">
                  {{ scope.row.oraDal | formattaHours }} / {{ scope.row.oraAl | formattaHours }}
                </div>
              </template>
            </el-table-column>

            <el-table-column header-align="center" align="center" :label="$t('autorizza.label.destinazione')"
              min-width="200">

              <template slot-scope="scope">
                <div class="name-wrapper">
                  {{ scope.row.desDest === undefined ? scope.row.desMan : scope.row.desDest }}
                </div>
              </template>

            </el-table-column>

            <el-table-column width="50">
              <template slot-scope="scope">
                <div class="data-wrapper" style="cursor: pointer">
                  <el-tooltip class="item" effect="dark" :content="$t('btn.approva')" placement="top-start">
                    <icon class="confirm" v-if="scope.row.statoAvanz === '1'" name="riv-tick" scale="1.2"
                      @click.native.stop="actionDiario(scope.row, '3')"></icon>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column width="50">
              <template slot-scope="scope">
                <div class="data-wrapper" style="cursor: pointer">
                  <el-tooltip class="item" effect="dark" :content="$t('btn.rifiuta')" placement="top-start">
                    <icon class="reject" v-if="scope.row.statoAvanz === '1'" name="elm-chiudi" scale="1.2"
                      @click.native.stop="actionDiario(scope.row, '2')"></icon>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

      </el-tab-pane>

      <el-tab-pane>
        <div style="width: 200px" slot="label">
          <div class="col-24 no-padding">
            {{ $t('trasferte.ticket').toUpperCase() }}
          </div>
          <div class="col-24 no-padding barra"></div>
        </div>

        <biglietti v-if="tabActive === '1'" :trasferta="trasferta" :key="trasferta.idTrasferta" :actionBar="false">
        </biglietti>

      </el-tab-pane>

      <el-tab-pane>
        <div style="width: 200px" slot="label">
          <div class="col-24 no-padding">
            {{ $t('trasferte.trasporti').toUpperCase() }}
          </div>
          <div class="col-24 no-padding barra"></div>
        </div>

        <trasporti v-if="tabActive === '2'" :trasferta="trasferta" :key="trasferta.idTrasferta" :actionBar="false">
        </trasporti>

      </el-tab-pane>
      <el-tab-pane>
        <div style="width: 200px" slot="label">
          <div class="col-24 no-padding">
            {{ $t('trasferte.auto').toUpperCase() }}
          </div>
          <div class="col-24 no-padding barra"></div>
        </div>

        <auto v-if="tabActive === '3'" :trasferta="trasferta" :tbl_genSta="[]" :key="trasferta.idTrasferta"
          :actionBar="false"></auto>

      </el-tab-pane>

      <el-tab-pane>
        <div style="width: 200px" slot="label">
          <div class="col-24 no-padding">
            {{ $t('trasferte.doc').toUpperCase() }}
          </div>
          <div class="col-24 no-padding barra"></div>
        </div>

        <documenti v-if="tabActive === '4'" :trasferta="trasferta" :key="trasferta.idTrasferta" :actionBar="false">
        </documenti>
      </el-tab-pane>
    </el-tabs>




  </div>
</template>
<script>
import Diario from '@/components/Trasferte/Diario.vue'
import Biglietti from '@/components/Trasferte/Biglietti.vue'
import Trasporti from '@/components/Trasferte/Trasporti.vue'
import Documenti from '@/components/Trasferte/Documenti.vue'
import Auto from '@/components/Trasferte/AutoAziendali.vue'

export default {
  components: {
    Diario,
    Trasporti,
    Biglietti,
    Documenti,
    Auto
  },
  name: 'DettaglioTrasferta',
  i18n: {
    messages: {
      it_IT: {
        autorizza: {
          label: {
            title: 'Trasferta',
            dataIn: 'Data Inizio',
            dataFin: 'Data Fine',
            partenza: 'Partenza',
            destinazione: 'Destinazione',
            soc: 'Per conto della Società',
            uffRep: 'Ufficio/Reparto',
            referente: 'Persona di Riferimento',
            motivo: 'Motivazione',
            giorno: 'Giorno',
            orario: 'Orario',
            notaResp: 'Nota Responsabile',
            authDiary: 'Vengono visualizzate solo le righe del diario che differiscono dalla destinazione di default'
          },
          msg: {
            respAppDiary: 'Sei sicuro di voler Approvare la riga di Diario?',
            respRejDiary: 'Sei sicuro di voler Rifiutare la riga di Diario?',
            respAppTrip: 'Sei sicuro di voler Approvare la Trasferta',
            respRejTrip: 'Sei sicuro di voler Rifiutare la Trasferta',
            info: 'Avviso!',
            abort: 'Operazione Annullata',
            noData: 'Nessun Documento trovato'
          }
        }
      },
      fr_FR: {
        autorizza: {
          label: {
            title: 'Deplacement',
            dataIn: 'Date du',
            dataFin: 'Date au',
            partenza: 'Départ',
            destinazione: 'Destination',
            soc: 'Pour le compte',
            uffRep: 'Bureau/département',
            referente: 'Personne de référence',
            motivo: 'Motif',
            giorno: 'Jour',
            orario: 'Horaire',
            notaResp: 'Responsable notes',
            authDiary: 'Sont visualisées seulement les lignes du journal de voyage que different de la destination de default.'
          },
          msg: {
            respAppDiary: 'Êtes-vous sur d\'approuver la ligne du jurnal de voyage?',
            respRejDiary: 'Êtes-vous sur de refuser la ligne du jurnal de voyage?',
            respAppTrip: 'Êtes-vous sur d\'approuver le déplacement?',
            respRejTrip: 'Êtes-vous sur de refuser le déplacement?',
            info: 'Info!',
            abort: 'Opération annulée',
            noData: 'Aucun document trouvé'
          }
        }
      },
      es_ES: {
        autorizza: {
          label: {
            title: 'Viaje',
            dataIn: 'Dia salida',
            dataFin: 'Dia regreso',
            partenza: 'Salida',
            destinazione: 'Destino',
            soc: 'Por cuenta de la sociedad',
            uffRep: 'Oficina/Empresa',
            referente: 'Persona de referencia',
            motivo: 'Referencia',
            giorno: 'Día',
            orario: 'Horas',
            notaResp: 'Nota Responsables',
            authDiary: 'Solo se muestran las líneas del registro de viaje que son diferentes del destino predeterminado.'
          },
          msg: {
            respAppDiary: '¿Está seguro que quiere aprobar la linea de la agenda?',
            respRejDiary: '¿Está seguro que quiere rechazar la linea de la agenda?',
            respAppTrip: '¿Está seguro de que desea aprobar la solicitud de viaje?',
            respRejTrip: '¿Está seguro que quiere rechazar la solicitud de viaje?',
            info: '¡Aviso!',
            abort: 'Operación cancelada',
            noData: 'Sin informacion'
          }
        }
      },
      de_DE: {
        autorizza: {
          label: {
            title: 'Dienstreise',
            dataIn: 'Reisebeginn',
            dataFin: 'Reiseende',
            partenza: 'Abreiseort',
            destinazione: 'Reiseziel',
            soc: 'auf Kosten der Firma',
            uffRep: 'Büro/Abteilung',
            referente: 'Ansprechpartner',
            motivo: 'Grund',
            giorno: 'Tag',
            orario: 'Zeitraum',
            notaResp: 'Verantwortliche Notiz',
            authDiary: 'Es werden nur Journalzeilen angezeigt, die vom Standardziel abweichen'
          },
          msg: {
            respAppDiary: 'Sind Sie sicher, dass Sie diese Reihe bestätigen möchten?',
            respRejDiary: 'Sind Sie sicher, dass Sie diese Reihe ablehnen möchten?',
            respAppTrip: 'Sind Sie sicher, dass Sie den Reiseantrag bestätigen möchten?',
            respRejTrip: 'Sind Sie sicher, dass Sie den Reiseantrag ablehnen möchten?',
            info: 'Beachten!',
            abort: 'Operation abgebrochen',
            noData: 'Kein Dokument gefunden'
          }
        }
      },
      en_GB: {
        trasferte: {}
      }
    }
  },
  data() {
    return {
      loading: false,
      idTrasferta: '',
      trasferta: {},
      form: {},
      diario: [],
      filterStato: '',
      currentPage: '1',
      pag_for: '8',
      pag_order: 'DD',
      stati: [
        { id: 'all', desc: this.$t('status.all'), icon: 'riv-tick' },
        { id: '0', desc: this.$t('status.0'), icon: 'riv-tick' },
        { id: '1', desc: this.$t('status.1'), icon: 'riv-tick' },
        { id: '2', desc: this.$t('status.2'), icon: 'riv-tick' },
        { id: '3', desc: this.$t('status.3'), icon: 'riv-tick' },
        { id: '4', desc: this.$t('status.4'), icon: 'riv-tick' },
        { id: '7', desc: this.$t('status.7'), icon: 'riv-tick' }
      ],
      statusDiario: 'all',
      tabActive: '-1',
      diario_toApprove: false,
    }
  },
  filters: {
    /* Formatta la data: GGMMAAAA --> GG/MM/AAAA */
    formattaData: function (date) {
      if (date !== undefined && date !== '') {
        return date.substr(6, 2) + '/' + date.substr(4, 2) + '/' + date.substr(0, 4)
      } else {
        return ' '
      }
    },
    formattaHours: function (hours) {
      if (hours !== '') {
        return hours.replace(',', ':')
      } else {
        return ' '
      }
    }
  },
  /*watch: {
    '$route' (to, from) {
      if (to.name === 'AutorizzaTrasferta') {
        this.loading = true
        this.idTrasferta = this.$route.params.id
        this.loadTrasferta(this.$route.params.id)
      }
    }
  },*/
  activated: function () {
    this.diario_toApprove = false
    this.loading = true
    this.idTrasferta = this.$route.params.id
    this.loadTrasferta(this.$route.params.id)
    this.tabActive = '-1'
  },
  /*beforeMount: function () {
    this.loading = true
    this.idTrasferta = this.$route.params.id
    this.loadTrasferta(this.$route.params.id)
  },*/
  methods: {
    link: function (route) {
      this.$router.push({ name: route })
    },
    loadTrasferta: function (idTrasferta) {
      this.loading = true
      this.$set(this, 'form', JSON.parse(sessionStorage.getItem('Trasferte_Aut_form')))
      this.$http.get('trasferte/' + this.$store.state.country + '/trasferte', {
        params: {
          idTrasferta: idTrasferta,
          vista: 'C',
          //daGestire: (this.form !== null && this.form.daGestire !== undefined && !this.form.daGestire) ? 'no' : 'si'
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.trasferta = response.body.data[0]
            this.tabActive = '0'
            this.loadDiario('all')
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    loadDiario: function (stato) {
      this.diario_toApprove = false
      this.$set(this, 'diario', [])
      this.loading = true
      let obj = {
        params: {
          'idTrasferta': this.trasferta.idTrasferta,
          'pag_action': (this.currentPage > 1) ? 'NEXT' : 'BEGIN',
          'pag_from': this.currentPage,
          'pag_for': this.pag_for,
          'pag_order': this.pag_order,
          'vista': 'R',
          'ccDipendente': this.trasferta.ccDipendente,
          'dataDal': this.trasferta.dataDal,
          'dataAl': this.trasferta.dataAl
        }
      }
      if (stato !== '' && stato !== 'all') {
        obj.params['statoRighe'] = stato
      }
      this.$http.get('trasferte/' + this.$store.state.country + '/diario', obj)
        .then(response => {
          if (response.body.rc === 0) {
            this.diario = response.body.data
            let diarioCount = 0
            for (let i = 0; i < this.diario.length; i++) {
              diarioCount += this.diario[i].statoAvanz === '1' ? 1 : 0
            }
            this.diario_toApprove = (diarioCount === 0 ? true : false)
          } else {
            this.diario_toApprove = true
          }
          this.loading = false
        })
    },
    actionTrasferta: function (stato) {
      let _this = this
      let message = stato === '3' ? this.$i18n.t('autorizza.msg.respAppTrip') : this.$i18n.t('autorizza.msg.respRejTrip')
      let btnAction = stato === '3' ? this.$i18n.t('btn.confermaApp') : this.$i18n.t('btn.confermaRej')
      this.$confirm(
        message, this.$i18n.t('autorizza.msg.info'), {
        confirmButtonText: btnAction,
        cancelButtonText: this.$i18n.t('btn.annulla'),
        type: 'info',
        callback: function (action) {
          if (action === 'confirm') {
            _this.setTrasferta(stato)
          } else {
            _this.$message({
              showClose: true,
              message: _this.$i18n.t('autorizza.msg.abort'),
              type: 'info',
              duration: process.env.duration
            })
          }
        }
      })
    },
    setTrasferta: function (statoAvanz) {
      this.loading = true
      let obj = {
        'idTrasferta': this.idTrasferta,
        'operazione': '*UPD',
        'statoAvanz': statoAvanz,
        'notaRes': this.trasferta.notaRes
      }
      this.$http.post('trasferte/' + this.$store.state.country + '/trasferta', obj)
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })
            this.loadTrasferta(this.idTrasferta)
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    actionDiario: function (row, stato) {
      let _this = this
      let message = stato === '3' ? this.$i18n.t('autorizza.msg.respAppDiary') : this.$i18n.t('autorizza.msg.respRejDiary')
      let btnAction = stato === '3' ? this.$i18n.t('btn.confermaApp') : this.$i18n.t('btn.confermaRej')
      this.$confirm(message, this.$i18n.t('autorizza.msg.info'), {
        confirmButtonText: btnAction,
        cancelButtonText: this.$i18n.t('btn.annulla'),
        type: 'info',
        showClose: false,
        closeOnClickModal: false,
        callback: function (action) {
          if (action === 'confirm') {
            _this.setDiario(row, stato)
          } else {
            _this.$message({
              showClose: true,
              message: _this.$i18n.t('autorizza.msg.abort'),
              type: 'info',
              duration: process.env.duration
            })
          }
        }
        /*}).then(() => {
          this.setDiario(row,stato)
        }).catch(() => {
          this.$message({
            showClose: true,
            message: _this.$i18n.t('autorizza.msg.abort'),
            type: 'info',
            duration: process.env.duration
          })*/
      })
    },
    setDiario: function (row, statoAvanz) {
      this.loading = true
      let obj = {
        idTrasferta: this.idTrasferta,
        statoAvanz: statoAvanz,
        righeDiario: [{
          id: row.id
        }],
        numRigheDiario: 1
      }

      this.$http.post('trasferte/' + this.$store.state.country + '/statodiario', obj)
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })
            this.loadDiario()
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    getStatoIcon_dett: function (stato) {
      switch (stato) {
        case '0':
          return 'riv-save2'
        case '1':
          return 'riv-save2'
        case '2':
          return 'riv-user'
        case '3':
        case '4':
          return 'riv-alloggio'
        default:
          return ''
      }
    },
    getStatoClass_dett: function (stato) {
      switch (stato) {
        case '0':
          return 'status-saved'
        case '1':
          return 'status-send'
        case '2':
          return 'status-rejected'
        case '3':
          return 'status-approved'
        case '4':
          return 'status-send'
        default:
          return ''
      }
    },
    getStato: function () {
      if (this.trasferta.terminata === 'T') {
        return '(' + this.$i18n.t('status.t') + ')'
      } else {
        return '(' + this.$i18n.t('status.' + this.trasferta.statoAvanz) + ')'
      }
    },
    getMotivo: function (nota) {
      return nota !== undefined ? nota.replace(/\\n|\\r\\n|\\n\\r|\\r/g, '<br>') : ''
    },
    getContatti: function (list, perRif) {
      let contatti = ''

      if (!Array.isArray(list)) {
        list = []; // fallback sicuro
      }

      for (let user of list) {
        contatti += user.mail + '; '
      }
      if (perRif) {
        contatti += perRif + '; '
      }
      return contatti
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";
@import "../../assets/less/el-button.less";
@import "../../assets/less/el-pagination.less";
@import "../../assets/less/el-table.less";

.dettaglio-trasferte {
  height: 100%;

  .header-tab {
    height: 80px;
    text-align: center;

    .return {
      margin-top: 10px;
      line-height: 55px;
      height: 45px;
      float: left;
      .set-font(@color: @greenRiva, @weight: bold);

      .fa-icon {
        float: left;
        cursor: pointer;
      }
    }

    .my-label {
      display: block;
      line-height: 55px;
      height: 45px;
      .set-font(@color: @oroRiva, @size: 22px, @weight: bold, @family: 'os-semibolditalic');
      letter-spacing: 2px;
    }

    .my-label-subtitle {
      display: block;
      .set-font(@size: 15px, @weight: normal, @family: 'os-lightitalic');
      height: 25px;
    }

    .inoltraBtn {
      float: right;
      padding-top: 12px;
      padding-right: 10px;
    }

  }

  .testata-trasferte {
    height: auto;

    .colonna-md {
      margin-left: 1px;
    }

    .colonna {
      height: 100%;
      margin-top: 20px;

      .blocco {
        .elemento {
          height: auto;

          .testata-label {
            .set-font(@color: @greenRiva; @size: 15px);
            display: inline;
            text-align: right;
            line-height: 16px;
            height: 22px;
            padding-top: 5px;
            padding-bottom: 5px;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .testata-value {
            .set-font(@color: #454848; @size: 13px);
            display: inline;
            text-align: left;
            word-wrap: break-word;
            white-space: normal;
            line-height: 16px;
            min-height: 26px;
            height: 100%;
            border-left: 1px solid @oroRiva;
            padding-top: 5px;
            padding-bottom: 5px;

            .icona {
              color: #54e912;
            }
          }
        }
      }

      .secondo-blocco {
        margin-top: 20px;
      }
    }
  }

  .el-tabs {
    margin-top: 40px;

    .el-tabs__header {
      border-bottom: 1px solid #ccc;
      margin-bottom: 0px;

      .el-tabs__nav-wrap {
        margin-top: 0px;
      }

      .el-tabs__nav-wrap::after {
        display: none;
      }

      .el-tabs__nav {
        border: 0px;
        height: 33px;

        .el-tabs__item {
          text-align: center;
          padding-left: 0px;
          padding-right: 0px;
          border: 0px;
          height: 30px;
          line-height: 30px;
          .set-font(@color: #999);
          letter-spacing: 1px;

          &.is-active {
            .set-font(@weight: bold);

            // background-color: #efe8da;
            .barra {
              background-image: linear-gradient(to right, @oroRiva, @greenRiva);
              height: 3px;
            }
          }
        }

        .el-tabs__item:hover {
          color: @greenRiva;
        }
      }
    }

  }

  /*
    .el-table::before {
      height: 0px;
    }
    .el-table {
      border-bottom: none;
      overflow: auto;
      margin-bottom: 10px;
      .el-table__header {
        border-bottom: 1px solid #007c74;
        thead {
          th {
            padding: 7px 0px;
            .cell {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding-left: 10px !important;
              .set-font(@color: @greenRiva; @weight: bold; @size: 15px);
            }
          }
        }
      }
      .el-table__body {
        tbody {
          tr {
            td {
              padding: 7px 0px;
              .cell {
                line-height: 16px;
                width: 100%;
                .set-font(@size: 13px; @color: #454848);
                .bottoni-alert {
                  display: grid;
                  .icon {
                    margin-bottom: 3px;
                    margin-left: 3px;
                  }
                }
                .confirm {
                  cursor: pointer;
                  color: @greenRiva;
                }
                .reject {
                  cursor: pointer;
                  color: red;
                }
              }
            }
          }
        }
      }
    }
    */
  .el-select {
    margin-left: 20px;

    .el-input__inner {
      height: 22px;
      line-height: 22px;
      border: 0px;
      border-bottom: 1px solid #e7e7e7;
      border-radius: 0px;
      padding-left: 0px;
      padding-right: 10px;
    }

    .el-input__suffix {
      right: -5px;
    }
  }

  .info-diario {
    height: 25px;
    line-height: 25px;
    text-align: center;
    display: block;
    //padding-top: 20px;
    color: gray;
    color: gray;
    .set-font(@size: 12px; @color: #454848);
  }
}

.selectTrasferta {
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Trasferte/AutorizzaTrasferta.vue